// @ts-nocheck
import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { css } from "styled-components";

Object.assign(priceStyles, {
    productPrice: {
        wrapper: {
            css: css`
                width: fit-content;
            `,
        },
        priceWrapper: {
            css: css`
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
            `,
        },
        price: {
            priceText: { size: 26 },
            unitOfMeasureText: { size: 22 },
        },
    },
});
